// extracted by mini-css-extract-plugin
export var button = "PlusLandingPageBase-module__button___kzQDb";
export var cancel = "PlusLandingPageBase-module__cancel___ZoTsj";
export var content = "PlusLandingPageBase-module__content___Kf4No";
export var copy = "PlusLandingPageBase-module__copy___pKZt9";
export var head = "PlusLandingPageBase-module__head___HtmY8";
export var headline = "PlusLandingPageBase-module__headline___DxbO1";
export var hero = "PlusLandingPageBase-module__hero___AYWh1";
export var lottie = "PlusLandingPageBase-module__lottie___jQLb3";
export var picture = "PlusLandingPageBase-module__picture___rX106";
export var subhead = "PlusLandingPageBase-module__subhead___JVIsl";
export var texture = "PlusLandingPageBase-module__texture___p9WbM";
export var title = "PlusLandingPageBase-module__title___aXgGR";
export var wrapper = "PlusLandingPageBase-module__wrapper___HRQDl";